// _services/bankService.js
import api from '../../../api/axios';
import axios from 'axios';

export const bankService = {
  // Obtener todas las configuraciones en paralelo
  getConfigs: async (slug) => {
    const token = localStorage.getItem("token");
    const [bankResponse, stripeResponse, banksResponse] = await Promise.all([
      api.get(`/admin/bank-config/${slug}`, {
        headers: { Authorization: `Bearer ${token}` },
      }),
      api.get(`/admin/stripe-config/${slug}`, {
        headers: { Authorization: `Bearer ${token}` },
      }),
      api.get(`/admin/bank-config/banks`, {
        headers: { Authorization: `Bearer ${token}` },
      })
    ]);
    return {
      bank: bankResponse.data,
      stripe: stripeResponse.data,
      banks: banksResponse.data
    };
  },

  // Guardar configuración del banco
  saveBankConfig: async (slug, data) => {
    const token = localStorage.getItem("token");
    const response = await api.put(`/admin/bank-config/${slug}`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  // Guardar configuración de Stripe
  saveStripeConfig: async (slug, data) => {
    const token = localStorage.getItem("token");
    const response = await api.put(`/admin/stripe-config/${slug}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
    });
    return response.data;
  },

  // Toggle Banco
  toggleBank: async (slug, isEnabled) => {
    const token = localStorage.getItem("token");
    const response = await api.patch(`/admin/bank-config/${slug}/toggle`, {
      is_enabled: isEnabled
    }, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  // Toggle Stripe
  toggleStripe: async (slug, isEnabled) => {
    const token = localStorage.getItem("token");
    const response = await api.patch(`/admin/stripe-config/${slug}/toggle`, {
      is_enabled: isEnabled
    }, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  // Generar QR de prueba (1 BOB)
  testQR: async (slug) => {
    // ✅ PAYLOAD LIMPIO: El backend (bnbApi.js) ya busca el account_id correcto por el slug.
    // No debemos enviar destinationAccountId desde el frontend por seguridad.
    const payload = {
      slug,
      currency: "BOB",
      gloss: "Prueba de configuración",
      amount: 1,
      singleUse: true,
      description: "QR de prueba para verificar configuración",
      expirationDate: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString().split('T')[0],
      additionalData: "Prueba técnica"
    };

    const response = await axios.post('/api/generate-qr', payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  },

// Probar Stripe
testStripe: async (slug) => {
  const token = localStorage.getItem("token");
  const response = await api.post('/admin/stripe-config/create-stripe-payment-intent', {
    eventSlug: slug,
    amount: 100,       // $1.00 USD en centavos
    currency: "usd",   // igual que el flujo real (Stripe no liquida en BOB)
    description: "Prueba de conexión Stripe"
  }, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
},
};